import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAppSelector } from '../../hooks/redux';
import { isAdmin, isCompany, isStaff } from '../../features/auth/authSlice';

interface ProtectedRouteProps {
    children: React.ReactNode;
    requiredRole?: 'admin' | 'company' | 'user';
    requiredRoles?: string[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requiredRole, requiredRoles }) => {
    const { user, isAuthenticated } = useAppSelector((state) => state.auth);

    if (!isAuthenticated || !user) {
        return <Navigate to="/login" replace />;
    }

    // Check single role requirement
    if (requiredRole && user.role !== requiredRole) {
        // Redirect to appropriate dashboard based on user role
        if (isAdmin(user)) {
            return <Navigate to="/admin" replace />;
        } else if (isCompany(user)) {
            return <Navigate to="/company" replace />;
        } else if (isStaff(user)) {
            return <Navigate to="/staff" replace />;
        } else {
            return <Navigate to="/dashboard" replace />;
        }
    }

    // Check multiple roles requirement
    if (requiredRoles && !requiredRoles.includes(user.role)) {
        // Redirect to appropriate dashboard based on user role
        if (isAdmin(user)) {
            return <Navigate to="/admin" replace />;
        } else if (isCompany(user)) {
            return <Navigate to="/company" replace />;
        } else if (isStaff(user)) {
            return <Navigate to="/staff" replace />;
        } else {
            return <Navigate to="/dashboard" replace />;
        }
    }

    return <>{children}</>;
};

export default ProtectedRoute;
